<template>
    <div class="mb-8">
        <div class="flex shadow-sm">
            <div class="flex items-center bg-gray-50 border border-r-0 border-gray-300 rounded-l-lg px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" 
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                    class="text-gray-400">
                    <circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
                </svg>
            </div>
            <div class="flex-1">
                <input 
                    id="search" 
                    type="text" 
                    class="w-full px-4 py-2.5 border border-gray-300 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-colors" 
                    placeholder="Search records..." 
                    v-model="record" 
                    @keyup="search"
                >
            </div>
            <button 
                class="px-4 py-2.5 bg-gray-50 text-gray-700 border border-l-0 border-gray-300 rounded-r-lg hover:bg-red-100 hover:border-red-300 transition-colors"
                @click="record = null; results=[];"
            >
                Clear
            </button>
        </div>

        <div v-if="results.length" class="w-full mt-2">
            <div class="w-full rounded-lg shadow-lg border text-xs lg:text-sm">
                <!-- Header -->
                <div class="grid grid-cols-9 py-1 px-2 bg-logo-dark text-white font-bold text-left rounded-t-lg">
                    <div class="col-span-3">Name</div>
                    <div class="col-span-1">Type</div>
                    <div class="col-span-1">Date</div>
                    <div class="col-span-1">Status</div>
                    <div class="col-span-1">Coder</div>
                    <div class="col-span-2">Order</div>
                </div>

                <!-- Rows -->
                <a v-for="(item, index) in results" 
                   :key="item.id" 
                   :href="`/agencies/${agency.id}/orders/${item.order_id}`"
                   class="grid grid-cols-9 py-1 px-2 odd:bg-purple-50 hover:bg-logo hover:text-white cursor-pointer">
                    <div class="col-span-3 text-sm">
                        {{ (index+1) + '. ' + item.name }}
                        <span v-if="item.coder_comment">
                            <span class="inline-flex items-baseline ml-1 text-green-400" :title="item.coder_comment">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                                </svg>
                            </span>
                        </span>
                    </div>
                    <div class="" v-text="item.document_type"></div>
                    <div class="" v-text="formatDate(item.date)"></div>
                    <div class="" v-text="status(item)"></div>
                    <div class="" v-text="item.user ? item.user.name.split(' ')[0] : '-'"></div>
                    <div class="col-span-2" v-text="item.order.number"></div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        props: {
            agency: Object
        },
        data() {
            return {
                record: null,
                results: [],
            }
        },
        computed: {

        },

        watch: {
            // search
        },

        methods: {
            formatDate(dateString) {
                const date = new Date(dateString);
                const utcDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                const options = { year: 'numeric', month: 'short', day: 'numeric' };
                return utcDate.toLocaleDateString('en-US', options);
            },

            search: _.debounce(function() {
                if (this.record.length > 1) {
                    axios.get(`/agencies/${this.agency.id}/assignments?search=${this.record}`)
                        .then(({data}) => {
                            this.results = data;
                        });
                }

            }, 250),

            status (item) {
                if (item.completed_at) {
                    return 'Completed';
                }

                if (item.problem) {
                    return 'Sent to Problems';
                }

                if (item.started_at) {
                    return 'Started';
                }

                return 'Not Started';
            }

        }
    }
</script>
